import { render, staticRenderFns } from "./GhostTrolley.vue?vue&type=template&id=d130963a&scoped=true"
import script from "./GhostTrolley.vue?vue&type=script&lang=js"
export * from "./GhostTrolley.vue?vue&type=script&lang=js"
import style0 from "./GhostTrolley.vue?vue&type=style&index=0&id=d130963a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d130963a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
